(ns app.team.validation
  (:require [clojure.string :as str]))

(def min-team-name-length
  2)

(def max-team-name-length
  50)

(def team-name-error-message
  (str "Team name must be between "
       min-team-name-length
       " and "
       max-team-name-length
       " characters."))

(def team-name-command-error-message
  (str "The length of the team name should be between "
       min-team-name-length
       " and "
       max-team-name-length
       " characters."))

(defn valid-team-name?
  [team-name]
  (<= min-team-name-length
      (count team-name)
      max-team-name-length))

(def email-regex
  #"[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?")

(def email-error-message
  "Please enter a valid email address.")

(defn email?
  [address]
  (and address
       (re-matches email-regex (str/lower-case (str address)))))
